import "./Header.css";
import { useUser } from "../../context/UserContext.js";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
const Header = () => {
  const { user } = useUser();
  const handleSignOut = () => {
    Cookies.remove("prgiToken");
    window.location.reload();
  };
  return (
    <header className="header">
      <nav className="navbar">
        <Link to="/">
          {/* <h1 className="logo">PRGI</h1>
           */}
          <img className="logo" src="./prgi-logo.png" alt="logo" />
        </Link>
        <ul className="nav-list">
          <Link to="/submit-title">
            <li className="nav-item">Submit Title</li>
          </Link>
          <Link to="/titles">
            <li className="nav-item">Titles</li>
          </Link>
          {/* {user !== null && (
            <li className="nav-item">
              <button className="signup-button" onClick={handleSignOut}>
                SIGN OUT
              </button>
            </li>
          )} */}
          {/* {user === null && (
            <Link to="/signin">
              <li className="nav-item">
                <button className="signup-button">SIGN IN</button>
              </li>
            </Link>
          )} */}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
